import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set New Password" subtitle="Choose a new password for your account" testid="reset-password-page">
      {!token ? (
        <div className="rounded-md border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800 flex items-center gap-2" data-testid="reset-no-token">
          <WarningCircle size={20} /> This reset link is invalid or incomplete. Please request a new one.
        </div>
      ) : done ? (
        <div className="text-center py-6" data-testid="reset-done">
          <CheckCircle size={48} weight="fill" className="text-emerald-500 mx-auto" />
          <h3 className="font-display text-xl mt-4 text-primary">Password Updated</h3>
          <p className="text-sm text-muted-foreground mt-1">You can now sign in with your new password.</p>
          <Link to="/login"><Button className="mt-6 rounded-full bg-primary hover:bg-[#113A64]">Go to Login</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-1.5"><Label>New Password</Label><Input type="password" name="new-password" autoComplete="new-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" data-testid="reset-new-password" /></div>
          {error && <div className="text-sm text-destructive" data-testid="reset-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-primary hover:bg-[#113A64]" data-testid="reset-submit">{loading ? "Updating…" : "Update Password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
